import {FilterOptionsEnvelope} from "src/app/api/model/response/FilterOptionsResponse";
import {
    CASE_TYPE_OPTION,
    CASE_TYPE_TO_CASE_SUB_TYPE_MAP,
    NA_COUNTRY_OPTION,
    TRANSPORTER_TYPE_OPTION
} from "src/app/config/DropDownConfig";
import {API_RESULT_SUCCESS} from "src/app/constant/Constants";

/**
 * Mock for POST /lighthouse/cases/filter-options: serves the static DropDownConfig lists in
 * the real envelope shape, so the USE_MOCK_DATA flip needs no call-site changes. Sorted
 * alphabetically to mirror the backend contract.
 */
export const mockFilterOptions = async (): Promise<FilterOptionsEnvelope> => {
    await new Promise(resolve => setTimeout(resolve, 200));
    const allSubTypes: string[] = [];
    Object.values(CASE_TYPE_TO_CASE_SUB_TYPE_MAP).forEach(options =>
        options.forEach(o => allSubTypes.push(o.value)));
    const caseSubTypes = Array.from(new Set(allSubTypes)).sort();
    return {
        result: API_RESULT_SUCCESS,
        msg: 'filter options loaded successfully',
        data: {
            referenceSubTypes: TRANSPORTER_TYPE_OPTION.map(o => o.value).sort(),
            caseTypes: CASE_TYPE_OPTION.map(o => o.value).sort(),
            caseSubTypes,
            countries: NA_COUNTRY_OPTION.map(o => o.value).sort()
        }
    };
};
